import { render, staticRenderFns } from "./HolidaysCalendar.vue?vue&type=template&id=01dcde02&scoped=true"
import script from "./HolidaysCalendar.vue?vue&type=script&lang=js"
export * from "./HolidaysCalendar.vue?vue&type=script&lang=js"
import style0 from "./HolidaysCalendar.vue?vue&type=style&index=0&id=01dcde02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dcde02",
  null
  
)

export default component.exports